import { useMemo } from 'react';
import { mathRound } from '../../../../utils/mathRound';

const totalText = (valueShifts, valueHours) =>
  (valueShifts !== undefined ? `${mathRound(valueShifts)} Shifts\n` : '') +
  (valueHours !== undefined ? `${mathRound(valueHours)} Hours` : '');

export const useFooter = (rows, typeMeasuring, selOrder) => {
  return useMemo(() => {
    if (!rows || rows.length === 0) {
      return null;
    }

    const totals = {};

    if (selOrder === 'Emp') {
      rows.forEach((item) => {
        const type = item.name.includes('(Shifts)')
          ? 'Shifts'
          : item.name.includes('(Hours)')
          ? 'Hours'
          : null;

        if (!type) return;

        if (!totals[type]) {
          totals[type] = {
            start: 0,
            earned: 0,
            total: 0,
            used: 0,
            planned: 0,
            remaining: 0,
          };
        }

        totals[type].start += item.start || 0;
        totals[type].earned += item.earned || 0;
        totals[type].total += item.total || 0;
        totals[type].used += item.used || 0;
        totals[type].planned += item.planned || 0;
        totals[type].remaining += item.remaining || 0;
      });
    } else if (selOrder === 'Acc') {
      totals[typeMeasuring] = {
        start: 0,
        earned: 0,
        total: 0,
        used: 0,
        planned: 0,
        remaining: 0,
      };
      rows.forEach((row) => {
        Object.keys(row).forEach((key) => {
          if (key === 'name') return;
          const value = parseFloat(row[key]) || 0;
          totals[typeMeasuring][key] += value;
        });
      });
    }

    return [
      'Total',
      totalText(totals.Shifts?.start, totals.Hours?.start),
      totalText(totals.Shifts?.earned, totals.Hours?.earned),
      totalText(totals.Shifts?.total, totals.Hours?.total),
      totalText(totals.Shifts?.used, totals.Hours?.used),
      totalText(totals.Shifts?.planned, totals.Hours?.planned),
      totalText(totals.Shifts?.remaining, totals.Hours?.remaining),
    ];
  }, [rows, selOrder, typeMeasuring]);
};
